/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type AllergyStatusTypes = typeof AllergyStatusTypes[keyof typeof AllergyStatusTypes];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AllergyStatusTypes = {
  Active: 'Active',
  Inactive: 'Inactive',
  Deleted: 'Deleted',
} as const;
